import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Trans, useTranslation } from 'react-i18next'
import styles from 'modules/Billing/Billing.module.scss'
import Placeholder from 'modules/Billing/subcomponents/Placeholder'
import { useBilling } from 'modules/Forms/Billing/useBilling'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useDispatch } from 'react-redux'
import useQueryParams from 'utils/hooks/useQueryParams'
import PropTypes from 'prop-types'
import { useHistory, useParams } from 'react-router'
import AccountsBillingForm from 'modules/Forms/Billing/AccountsBillingForm'
import Billing from 'modules/Forms/Billing/hoc/Billing'
import Notification from 'modules/Billing/subcomponents/Notification'
import SERVICES_API_V2 from 'api/services/v2'
import { notificationShow } from 'modules/Notifications/actions'
import GridSpinner from 'components/UI/GridSpinner'
import { useNetworksData } from 'modules/Services/hooks/useNetworksData'
import PageHeader from 'components/PageHeader'
import { Button, Typography } from 'gu-ui-kit'
import { TOGGLE_PANEL } from 'modules/Tickets/types'

const AccountsReplenish = () => {
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  const { getPaymentMethods, data: { methods: { loaded } } = {} } = useBilling('accounts-billing')
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const { query: { ids = [] } = {} } = useQueryParams()
  const { networkType } = useParams()
  const { t } = useTranslation(['billing'])
  const { networkId } = useNetworksData(networkType)
  const [queryAccounts, setQueryAccounts] = useState([])

  useEffect(() => {
    networkId && getPaymentMethods({ networkId })
  }, [networkId])

  useEffect(() => {
    if (ids.length === 0) {
      dispatch(
        notificationShow({
          type: 'warning',
          message: t('billing::accounts_replenish.notifications.has_no_accounts'),
        }),
      )

      history.push(
        pathGen(ROUTES.SERVICES_NETWORK, {
          networkType,
        }),
      )

      return
    }

    Promise.all(
      ids.map(async (id) => {
        const { response } = await SERVICES_API_V2.getNetworkAccountById({
          accountId: id,
        })

        return response.data
      }),
    )
      .then((accounts) => {
        const filtered = accounts.filter(
          ({ main_action }) => main_action === 'deposit', // все аккаунты с возможностью пополнения
        )

        setQueryAccounts(filtered)

        return filtered
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    <>
      <Helmet defer={false}>
        <title>{t('head.deposit.title')}</title>
      </Helmet>

      <Billing>
        {!loaded ? (
          <Placeholder />
        ) : (
          <>
            <div className={styles['billing__content-top']}>
              <Notification />

              <PageHeader className={'layout-tile margin-bottom-16'}>
                {t('balance_replenishment')}
              </PageHeader>

              {loading && <GridSpinner />}

              {networkType && (
                <div className={'layout-tile'}>
                  <AccountsBillingForm
                    networkId={networkId}
                    onClose={() =>
                      history.push(
                        pathGen(ROUTES.SERVICES_NETWORK, {
                          networkType,
                        }),
                      )
                    }
                    queryAccounts={queryAccounts}
                  />
                </div>
              )}
            </div>
            <div className={'padding-16'}>
              <Typography
                variant={'Body-Forms-20'}
                color={'Label-Secondary'}
              >
                <Trans i18nKey={'billing::info'}>
                  Средства поступают на ваш баланс сразу. В редких случаях перевод может занять до
                  24 часов. При возникновении проблем обратитесь в
                  <Button
                    color={'Label-GU-Primary'}
                    component={'span'}
                    variant={'ghost'}
                    link
                    onClick={() => dispatch({ type: TOGGLE_PANEL, payload: true })}
                  >
                    тикеты
                  </Button>
                </Trans>
              </Typography>
            </div>
          </>
        )}
      </Billing>
    </>
  )
}

AccountsReplenish.propTypes = {
  onClose: PropTypes.func,
}
export default AccountsReplenish
